module.exports = __webpack_public_path__ + "static/media/29DUNON13.97e11e6e.jpg";